import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Snackbar,
  Tab,
  Tabs,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useRetailerTicketFormMutation } from "../../../services/Dynamo/mutation";
import { useRetailerTicketFormList } from "../../../services/Dynamo/query";
import { useLoader } from "../../../services/providers/LoaderProvider";
import { langs } from "../../../utils/interface";
import { Country, CountryKey } from "../../../utils/models/Common.model";
import { RetailerTicket } from "../../../utils/models/Ticket.model";

export function TabsLangTicketFormRetailer() {
  const [showNotificationSuccess, setShowNotificationSuccess] =
    useState<boolean>(false);
  const [value, setValue] = useState<undefined | CountryKey>(langs[0]);
  const {
    isLoading,
    items: itemRetailer,
    refetch,
  } = useRetailerTicketFormList();
  const { setLoading } = useLoader("TicketForm");
  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  const {
    isLoading: isLoadingMutRetailer,
    error: errorMutRetailer,
    mutateItem: mutateItemRetailer,
  } = useRetailerTicketFormMutation();
  const onSave = useCallback(
    (element: RetailerTicket) => {
      mutateItemRetailer(element).then(() => {
        setShowNotificationSuccess(true);
        setTimeout(() => {
          setShowNotificationSuccess(false);
          refetch();
        }, 2000);
      });
    },
    [mutateItemRetailer, refetch]
  );
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value || false}
            onChange={(_, value) => setValue(value)}
            aria-label="basic tabs example"
          >
            {langs.map((key) => (
              <Tab key={key} label={Country[key]} value={key} />
            ))}
          </Tabs>
        </Box>
        {langs.map((key) => (
          <SingleElement
            lang={key}
            selectedLang={value}
            ticketForm={itemRetailer?.find((ticket) => ticket.country === key)}
            onSave={onSave}
          ></SingleElement>
        ))}
      </Box>
      {showNotificationSuccess && (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={true}
          message="Operation carried out successfully"
        >
          <Alert
            sx={{ color: "white", backgroundColor: "#1D4EBB" }}
            severity="info"
          >
            Operation carried out successfully
          </Alert>
        </Snackbar>
      )}
    </div>
  );
}

function SingleElement({
  lang,
  selectedLang,
  ticketForm,
  onSave,
}: {
  lang: string;
  selectedLang?: string;
  ticketForm?: RetailerTicket;
  onSave: (ticketForm: RetailerTicket) => void;
}) {
  const [address3, setAddress3] = useState<boolean>(false);
  const [province, setProvince] = useState<boolean>(false);

  useEffect(() => {
    setAddress3(ticketForm?.enable_address_3 || false);
    setProvince(ticketForm?.enable_province || false);
  }, [ticketForm]);

  const handleSaveRetailer = () => {
    const oldTicketForm = ticketForm || {};
    onSave({
      ...oldTicketForm,
      enable_address_3: address3,
      enable_province: province,
    } as RetailerTicket);
  };

  return (
    <>
      <div role="tabpanel" hidden={selectedLang !== lang}>
        <div className="container mx-auto">
          <div className="grid grid-cols-3 grid-rows-1 gap-4 mt-4">
            <div className="flex items-center">
              <div className="mt-1">
                <Checkbox
                  checked={address3}
                  onChange={(event) => {
                    setAddress3(event.target.checked)
                    setProvince(!event.target.checked)
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
              <p className="font-semibold">Address 3</p>
            </div>
            <div className="flex items-center">
              <div className="mt-1">
                <Checkbox
                  checked={province}
                  onChange={(event) => {
                    setProvince(event.target.checked)
                    setAddress3(!event.target.checked)
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </div>
              <p className="font-semibold">Province</p>
            </div>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            variant="contained"
            onClick={handleSaveRetailer}
            className="buttons-style"
          >
            <SaveIcon className="icon-button" />
            <span className="w-full">Save Language {selectedLang}</span>
          </Button>
        </div>
      </div>
    </>
  );
}
